module.exports = __webpack_public_path__ + "static/media/r317.61e89da5.jpg";